import React from 'react';
import { DialogBg } from '../../styles/layOutStyles';
import CustomLoading from './CustomLoading';

const Loading = ({ open, backColorOff }) => {
  return (
    <DialogBg open={open} backColorOff={backColorOff}>
      <CustomLoading />
    </DialogBg>
  );
};

export default Loading;
